<app-alerts />

@if (form$ | async; as form) {
  <app-admin-box-details-form
    [isEditContext]="true"
    (submitClickEvent)="handleSubmitClickEvent($event)"
    [data]="form" />
} @else {
  <app-spinner-filled />
}
